const trimTrailingSlashes = (value) => value.replace(/\/+$/, "");

export const getApiBaseUrl = () => {
  // Production must stay same-origin so CloudFront signs the private Lambda URL origin.
  const backendUrl = process.env.NODE_ENV === "development" ? process.env.REACT_APP_BACKEND_URL || "" : "";
  return `${trimTrailingSlashes(backendUrl)}/api`;
};

export const API_BASE_URL = getApiBaseUrl();
